import { Injectable } from '@angular/core';
import { ApiService } from '@core/http';
import { Observable } from 'rxjs';
import { ESavedView } from 'src/app/project/modules/saved-views/models/saved-view.enum';
import { TSavedView } from 'src/app/project/modules/saved-views/models/saved-view.model';
import { TSavedViews } from 'src/app/project/modules/saved-views/models/saved-views.model';
import { EWorkspaces } from 'src/app/project/modules/workspace/workspaces.enum';
import {
  API_views_default,
  API_views_delete,
  API_views_reorder,
  API_views_view,
  API_views_workspace,
} from './saved-views.paths';

@Injectable({
  providedIn: 'root',
})
export class SavedViewsProviderService {
  constructor(private apiService: ApiService) {}

  getViews(workspaceId: string): Observable<TSavedViews> {
    const requestWorkspaceId = Object.values(EWorkspaces).includes(workspaceId as EWorkspaces)
      ? null
      : workspaceId;

    const url = API_views_workspace(requestWorkspaceId);
    return this.apiService.get(url);
  }

  getView(workspaceId: string, viewId: string): Observable<TSavedView> {
    const requestWorkspaceId = Object.values(EWorkspaces).includes(workspaceId as EWorkspaces)
      ? null
      : workspaceId;

    const url = API_views_view(requestWorkspaceId, viewId);

    return this.apiService.get(url);
  }

  createView(workspaceId: string, view: Partial<TSavedView>): Observable<TSavedView> {
    const requestWorkspaceId = Object.values(EWorkspaces).includes(workspaceId as EWorkspaces)
      ? null
      : workspaceId;

    const url = API_views_workspace(requestWorkspaceId);

    return this.apiService.post(url, view);
  }

  editView(workspaceId: string, view: Partial<TSavedView>): Observable<TSavedView> {
    const requestWorkspaceId = Object.values(EWorkspaces).includes(workspaceId as EWorkspaces)
      ? null
      : workspaceId;

    const url = API_views_view(requestWorkspaceId, view.id);
    return this.apiService.put(url, view);
  }

  deleteView(viewId: string, workspaceId: string): Observable<null> {
    const requestWorkspaceId = Object.values(EWorkspaces).includes(workspaceId as EWorkspaces)
      ? null
      : workspaceId;

    const url = API_views_delete(requestWorkspaceId, viewId);

    return this.apiService.delete(url);
  }

  setDefaultView(workspaceId: string, viewId: string, type: ESavedView): Observable<TSavedViews> {
    const requestWorkspaceId = Object.values(EWorkspaces).includes(workspaceId as EWorkspaces)
      ? null
      : workspaceId;

    const url = API_views_default();
    const body = {
      viewType: type,
      viewId,
      workspaceId: requestWorkspaceId,
    };

    return this.apiService.put(url, body);
  }

  deleteDefaultView(workspaceId: string, type: ESavedView): Observable<null> {
    const requestWorkspaceId = Object.values(EWorkspaces).includes(workspaceId as EWorkspaces)
      ? null
      : workspaceId;

    const url = API_views_default();

    const body = {
      viewType: type,
      viewId: null,
      workspaceId: requestWorkspaceId,
    };

    return this.apiService.put(url, body);
  }

  reorderViews(
    workspaceId: string,
    viewId: string,
    viewType: ESavedView,
    newOrder: number,
  ): Observable<null> {
    const requestWorkspaceId = Object.values(EWorkspaces).includes(workspaceId as EWorkspaces)
      ? null
      : workspaceId;

    const url = API_views_reorder();
    const body = {
      workspaceId: requestWorkspaceId,
      viewId,
      viewType,
      index: newOrder,
    };

    return this.apiService.put(url, body);
  }
}
